// :cow: Cosmose CONFIDENTIAL :iso:
import { Step } from '@med/app/home/demo/guided-tour/models/step';
import { PlannerBasicDemoStepEnum } from '@med/app/home/planner-basic-demo/planner-basic-demo-step.enum';

export const plannerBasicDemoSteps: Step[] = [
  {
    stepId: PlannerBasicDemoStepEnum.campaignListAddNewCampaign,
    url: '/campaigns',
    dialog: {
      description: 'page.planner.guidedTour.china.campaignListAddNewCampaign.description',
      nextStepDescription: 'page.planner.guidedTour.china.campaignListAddNewCampaign.nextStepDescription',
      hideExitDemo: false,
      displayNextStepButton: false,
    },
    portal: {
      selector: '[data-demo-planner-basic="campaignListAddNewCampaign"] button',
      exposedElement: {
        selector: '[data-demo-planner-basic="campaignListAddNewCampaign"] button',
        preventDefault: true,
      },
    },
  },
  {
    stepId: PlannerBasicDemoStepEnum.campaignObjectiveSelectNewStoreOpening,
    url: '/objective',
    dialog: {
      description: 'page.planner.guidedTour.china.campaignObjectiveSelectNewStoreOpening.description',
      nextStepDescription: 'page.planner.guidedTour.china.campaignObjectiveSelectNewStoreOpening.nextStepDescription',
      hideExitDemo: false,
      displayNextStepButton: false,
    },
    portal: {
      selector: '[data-demo-planner-basic="campaignObjectiveSelectNewStoreOpening"] .objective__option--name:first-child',
      exposedElement: {
        selector: '[data-demo-planner-basic="campaignObjectiveSelectNewStoreOpening"] .objective__option--name:first-child .list-item',
        preventDefault: true,
      },
    },
  },
  {
    stepId: PlannerBasicDemoStepEnum.plannerStartSelectAudience,
    url: '/campaign/demo/planner-basic',
    dialog: {
      description: 'page.planner.guidedTour.china.plannerStartSelectAudience.description',
      nextStepDescription: 'page.planner.guidedTour.china.plannerStartSelectAudience.nextStepDescription',
      hideExitDemo: false,
      displayNextStepButton: false,
    },
    portal: {
      selector: '[data-demo-planner-basic="plannerStartSelectAudience"]',
      exposedElement: {
        selector: '[data-demo-planner-basic="plannerStartSelectAudience"]',
        preventDefault: true,
      },
    },
  },
  {
    stepId: PlannerBasicDemoStepEnum.audienceShowEstimates,
    url: '/campaign/demo/planner-basic/audience',
    dialog: {
      description: 'page.planner.guidedTour.china.audienceShowEstimates.description',
      hideExitDemo: false,
      displayNextStepButton: true,
    },
    portal: {
      selector: '[data-demo-planner-basic="audienceShowEstimates"]',
    },
  },
  {
    stepId: PlannerBasicDemoStepEnum.audienceReadSegmentDescriptions,
    url: '/campaign/demo/planner-basic/audience',
    dialog: {
      description: 'page.planner.audience.ownStoresTooltip',
      hideExitDemo: false,
      displayNextStepButton: true,
    },
    portal: {
      selector: '[data-demo-planner-basic="audienceReadSegmentDescriptions"]',
    },
  },
  {
    stepId: PlannerBasicDemoStepEnum.audienceAnalyzeLocationCategories,
    url: '/campaign/demo/planner-basic/audience',
    dialog: {
      description: 'page.planner.guidedTour.japan.audienceAnalyzeLocationCategories.description',
      hideExitDemo: false,
      displayNextStepButton: true,
    },
    portal: {
      selector: '[data-demo-planner-basic="audienceAnalyzeLocationCategories"]',
    },
  },
  {
    stepId: PlannerBasicDemoStepEnum.audienceClickEditBusinessCategories,
    url: '/campaign/demo/planner-basic/audience',
    dialog: {
      description: 'page.planner.guidedTour.japan.audienceClickEditLocationCategories.description',
      nextStepDescription: 'page.planner.guidedTour.japan.audienceClickEditLocationCategories.nextStepDescription',
      hideExitDemo: false,
      displayNextStepButton: false,
    },
    portal: {
      selector: '[data-demo-planner-basic="audienceClickEditLocationCategories"]',
      exposedElement: {
        selector: '[data-demo-planner-basic="audienceClickEditLocationCategories"]',
        preventDefault: false,
      },
    },
  },
  {
    stepId: PlannerBasicDemoStepEnum.audienceSelectLocationCategories,
    url: '/campaign/demo/planner-basic/audience',
    dialog: {
      description: 'page.planner.guidedTour.japan.audienceSelectLocationCategories.description',
      nextStepDescription: 'page.planner.guidedTour.japan.audienceSelectLocationCategories.nextStepDescription',
      hideExitDemo: false,
      displayNextStepButton: false,
    },
    portal: {
      selector: '[data-demo-planner-basic="audienceSelectLocationCategories"] e-business-categories-dialog-contents e-subcategory:nth-child(1) .collapsable-section',
      exposedElement: {
        selector: '[data-demo-planner-basic="audienceSelectLocationCategories"] e-business-categories-dialog-contents e-subcategory:nth-child(1) .collapsable-section .collapsable-section__header-left-checkbox',
        preventDefault: false,
      },
    },
  },
  {
    stepId: PlannerBasicDemoStepEnum.audienceExpandCategory,
    url: '/campaign/demo/planner-basic/audience',
    dialog: {
      description: 'page.planner.guidedTour.japan.audienceExpandCategory.description',
      nextStepDescription: 'page.planner.guidedTour.japan.audienceExpandCategory.nextStepDescription',
      hideExitDemo: false,
      displayNextStepButton: false,
    },
    portal: {
      isFixed: true,
      selector: '[data-demo-planner-basic="audienceExpandCategory"] .collapsable-section__header-right-side',
      exposedElement: {
        selector: '[data-demo-planner-basic="audienceExpandCategory"] .collapsable-section__header-right-side',
        preventDefault: false,
      },
    },
  },
  {
    stepId: PlannerBasicDemoStepEnum.audienceCloseLocationCategoriesDialog,
    url: '/campaign/demo/planner-basic/audience',
    dialog: {
      description: 'page.planner.guidedTour.japan.audienceCloseLocationCategoriesDialog.description',
      nextStepDescription: 'page.planner.guidedTour.japan.audienceCloseLocationCategoriesDialog.nextStepDescription',
      hideExitDemo: false,
      displayNextStepButton: false,
    },
    portal: {
      isFixed: true,
      selector: '[data-demo-planner-basic="audienceCloseLocationCategoriesDialog"]',
      exposedElement: {
        selector: '[data-demo-planner-basic="audienceCloseLocationCategoriesDialog"]',
        preventDefault: false,
      },
    },
  },
  {
    stepId: PlannerBasicDemoStepEnum.audienceExplainAddingLocationCategories,
    url: '/campaign/demo/planner-basic/audience',
    dialog: {
      description: 'page.planner.guidedTour.china.audienceExplainAddingLocationCategories.description',
      hideExitDemo: false,
      displayNextStepButton: true,
    },
    portal: {
      selector: '[data-demo-planner-basic="audienceAnalyzeLocationCategories"]',
    },
  },
  {
    stepId: PlannerBasicDemoStepEnum.audienceAskToSelectCity,
    url: '/campaign/demo/planner-basic/audience',
    dialog: {
      description: 'page.planner.guidedTour.japan.audienceAskToSelectCity.description',
      nextStepDescription: 'page.planner.guidedTour.japan.audienceAskToSelectCity.nextStepDescription',
      hideExitDemo: false,
      displayNextStepButton: false,
    },
    portal: {
      selector: '[data-demo-planner-basic="audienceAskToSelectCity"]',
      exposedElement: {
        selector: '[data-demo-planner-basic="audienceAskToSelectCity"] .selectable-tile-list__tile:nth-child(2)',
        preventDefault: false,
      },
    },
  },
  {
    stepId: PlannerBasicDemoStepEnum.audienceShowTimespan,
    url: '/campaign/demo/planner-basic/audience',
    dialog: {
      description: 'page.planner.guidedTour.china.audienceShowTimespan.description',
      hideExitDemo: false,
      displayNextStepButton: true,
    },
    portal: {
      selector: '[data-demo-planner-basic="audienceShowTimespan"]',
    },
  },
  {
    stepId: PlannerBasicDemoStepEnum.audienceAskToClickContinue,
    url: '/campaign/demo/planner-basic/audience',
    dialog: {
      description: 'page.planner.guidedTour.china.audienceAskToClickContinue.description',
      nextStepDescription: 'page.planner.guidedTour.china.audienceAskToClickContinue.nextStepDescription',
      hideExitDemo: false,
      displayNextStepButton: false,
    },
    portal: {
      isFixed: true,
      selector: '[data-demo-planner-basic="audienceAskToClickContinue"]',
      exposedElement: {
        selector: '[data-demo-planner-basic="audienceAskToClickContinue"]',
        preventDefault: true,
      },
    },
  },
  {
    stepId: PlannerBasicDemoStepEnum.demographicsSelectGender,
    url: '/campaign/demo/planner-basic/groups',
    dialog: {
      description: 'page.planner.guidedTour.china.demographicsSelectGender.description',
      nextStepDescription: 'page.planner.guidedTour.china.demographicsSelectGender.nextStepDescription',
      hideExitDemo: false,
      displayNextStepButton: false,
    },
    portal: {
      selector: '[data-demo-planner-basic="demographicsSelectGender"]',
      exposedElement: {
        selector: '[data-demo-planner-basic="demographicsSelectGender"]',
        preventDefault: false,
      },
    },
  },
  {
    stepId: PlannerBasicDemoStepEnum.demographicsAskToClickContinue,
    url: '/campaign/demo/planner-basic/groups',
    dialog: {
      description: 'page.planner.guidedTour.china.demographicsAskToClickContinue.description',
      nextStepDescription: 'page.planner.guidedTour.china.demographicsAskToClickContinue.nextStepDescription',
      hideExitDemo: false,
      displayNextStepButton: false,
    },
    portal: {
      isFixed: true,
      selector: '[data-demo-planner-basic="demographicsAskToClickContinue"]',
      exposedElement: {
        selector: '[data-demo-planner-basic="demographicsAskToClickContinue"]',
        preventDefault: true,
      },
    },
  },
  {
    stepId: PlannerBasicDemoStepEnum.mediaSearchPlatform,
    url: '/campaign/demo/planner-basic/media',
    dialog: {
      description: 'page.planner.guidedTour.japan.mediaSearchPlatform.description',
      hideExitDemo: false,
      displayNextStepButton: true,
    },
    portal: {
      selector: '[data-demo-planner-basic="mediaSearchPlatform"] .mat-form-field-flex',
    },
  },
  {
    stepId: PlannerBasicDemoStepEnum.mediaExpandPlatform,
    url: '/campaign/demo/planner-basic/media',
    dialog: {
      description: 'page.planner.guidedTour.japan.mediaExpandPlatform.description',
      hideExitDemo: false,
      displayNextStepButton: false,
    },
    portal: {
      selector: '[data-demo-planner-basic="media-platforms"] .platform-details__header--name',
      exposedElement: {
        selector: '[data-demo-planner-basic="media-platforms"] .platform-details__header--name',
        preventDefault: false,
      },
    },
  },
  {
    stepId: PlannerBasicDemoStepEnum.mediaSelectFormat,
    url: '/campaign/demo/planner-basic/media',
    dialog: {
      description: 'page.planner.guidedTour.japan.mediaSelectFormat.description',
      nextStepDescription: 'page.planner.guidedTour.japan.mediaSelectFormat.nextStepDescription',
      hideExitDemo: false,
      displayNextStepButton: false,
    },
    portal: {
      selector: '[data-demo-planner-basic="media-platforms"] .media__media-platform:nth-child(4)',
      exposedElement: {
        selector: '[data-demo-planner-basic="media-platforms"] .media__media-platform:nth-child(4)',
        preventDefault: false,
      },
    },
  },
  {
    stepId: PlannerBasicDemoStepEnum.mediaAskToClickContinue,
    url: '/campaign/demo/planner-basic/media',
    dialog: {
      description: 'page.planner.guidedTour.china.mediaAskToClickContinue.description',
      nextStepDescription: 'page.planner.guidedTour.china.mediaAskToClickContinue.nextStepDescription',
      hideExitDemo: false,
      displayNextStepButton: false,
    },
    portal: {
      isFixed: true,
      selector: '[data-demo-planner-basic="mediaAskToClickContinue"]',
      exposedElement: {
        selector: '[data-demo-planner-basic="mediaAskToClickContinue"]',
        preventDefault: true,
      },
    },
  },
  {
    stepId: PlannerBasicDemoStepEnum.budgetSelectCampaignDuration,
    url: '/campaign/demo/planner-basic/budget',
    dialog: {
      description: 'page.planner.guidedTour.china.budgetSelectCampaignDuration.description',
      hideExitDemo: false,
      displayNextStepButton: true,
    },
    portal: {
      selector: '[data-demo-planner-basic="budgetSelectCampaignDuration"]',
    },
  },
  {
    stepId: PlannerBasicDemoStepEnum.budgetCalculationExplanation,
    url: '/campaign/demo/planner-basic/budget',
    dialog: {
      description: 'page.planner.guidedTour.china.budgetCalculationExplanation.description',
      hideExitDemo: false,
      displayNextStepButton: true,
    },
    portal: {
      selector: '[data-demo-planner-basic="budgetCalculationExplanation"]',
    },
  },
  {
    stepId: PlannerBasicDemoStepEnum.budgetAskToClickSummary,
    url: '/campaign/demo/planner-basic/budget',
    dialog: {
      description: 'page.planner.guidedTour.china.mediaAskToClickContinue.description',
      nextStepDescription: 'page.planner.guidedTour.china.mediaAskToClickContinue.nextStepDescription',
      hideExitDemo: false,
      displayNextStepButton: false,
    },
    portal: {
      isFixed: true,
      selector: '[data-demo-planner-basic="budgetAskToClickSummary"]',
      exposedElement: {
        selector: '[data-demo-planner-basic="budgetAskToClickSummary"]',
        preventDefault: true,
      },
    },
  },
  {
    stepId: PlannerBasicDemoStepEnum.summaryAskToClickSendForReview,
    url: '/campaign/demo/summary',
    dialog: {
      description: 'page.planner.guidedTour.china.summaryAskToClickSendForReview.description',
      nextStepDescription: 'page.planner.guidedTour.china.summaryAskToClickSendForReview.nextStepDescription',
      hideExitDemo: false,
      displayNextStepButton: false,
    },
    portal: {
      isFixed: true,
      selector: '[data-demo-planner-basic="summaryAskToClickSendForReview"]',
      exposedElement: {
        selector: '[data-demo-planner-basic="summaryAskToClickSendForReview"]',
        preventDefault: true,
      },
    },
  },
  {
    stepId: PlannerBasicDemoStepEnum.sentForReviewAskToClickBackToDashboard,
    url: '/campaign/demo/success',
    dialog: {
      description: 'page.planner.guidedTour.china.sentForReviewAskToClickBackToDashboard.description',
      nextStepDescription: 'page.planner.guidedTour.china.sentForReviewAskToClickBackToDashboard.nextStepDescription',
      hideExitDemo: false,
      displayNextStepButton: false,
    },
    portal: {
      isFixed: true,
      selector: '[data-demo-planner-basic="sentForReviewAskToClickBackToDashboard"]',
      exposedElement: {
        selector: '[data-demo-planner-basic="sentForReviewAskToClickBackToDashboard"]',
        preventDefault: true,
      },
    },
  },
  {
    stepId: PlannerBasicDemoStepEnum.campaignListExposeCampaign,
    url: '/campaigns?page=0&size=12&sortBy=createdTime&sortDir=desc',
    dialog: {
      description: 'page.planner.guidedTour.china.campaignListExposeCampaign.description',
      hideExitDemo: true,
      displayNextStepButton: false,
      displayExitCampaignButton: true,
    },
    portal: {
      selector: '[data-demo-planner-basic="campaignListExposeCampaign"] .list-element',
    },
  },
];
